import React from "react";

function useBodyTourStep() {
    const [step, setStep] = React.useState(() =>
      Number(document.body.dataset.tourStep ?? -1)
    );
  
    React.useEffect(() => {
      const update = () => setStep(Number(document.body.dataset.tourStep ?? -1));
  
      // chạy ngay lần đầu
      update();
  
      const mo = new MutationObserver(update);
      mo.observe(document.body, { attributes: true, attributeFilter: ['data-tour-step'] });
  
      return () => mo.disconnect();
    }, []);
  
    return step;
  }

export default useBodyTourStep;